module.exports = __webpack_public_path__ + "static/media/success_icon.2a7ce2b2.svg";